<template></template>

<script>
export default {
  props: {
    callback: Function
  },
  created() {
    this.callback();
  }
};
</script>

<style>
</style>